import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Joi from "joi";
import http from "../services/http";
import Input from "./common/input";

const apiEndPoint = "/user-reset/link";

const Reset = () => {
  const [email, setEmail] = useState("");
  const [allow, setAllow] = useState(true);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.title = "FTR - Reset Password";
    return () => {
      document.title = "FTR";
    };
  }, []);

  async function handleReset(e) {
    e.preventDefault();
    const error = validate(email);
    if (error) return setErrors(error);
    try {
      await http.post(apiEndPoint + `/${email}`);
      toast.success("Email Sent");
      setAllow(false);
    } catch (ex) {
      if (ex.response.status >= 400 || ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
  }

  function validate(email) {
    const { error } = Joi.object({ email: Joi.string().email({ tlds: false }) }).validate({ email });
    if (!error) return null;
    return { EMAIL: error.details[0].message };
  }

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-6">
          <h1 className="display-4 text-center">Reset Your Password</h1>
          <p className="lead">
            Enter the email address associated with your account and we will
            send you instructions to access the system.
          </p>
          <p className="lead">We will never send your old password.</p>
        </div>
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-4">
          <form>
            <Input
              name="EMAIL"
              label="Email Address"
              placeholder="Email"
              value={email}
              error={errors.EMAIL}
              onChange={({ currentTarget: input }) => setEmail(input.value)}
            />
            <button
              className="btn btn-outline-success"
              onClick={handleReset}
              disabled={!allow}
            >
              Reset Password
            </button>
            {!allow && <p className="lead">Please check your Inbox.</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Reset;
